module.exports = __webpack_public_path__ + "img/duplicate.12aefdc6.png";